import { cache } from '../cache';
import { estClient } from './estClient';

export interface RingostatConfigReponse {
  success: true;
  ringostatConfig: {
    ringostatConfig: RingostatConfig;
  };
}

export interface RingostatConfig {
  isEnabled: boolean;
  projectId: string | '';
  authKey: string | '';
}

class PhoneApi {
  async performCall(body: { from: string; to: string }): Promise<void> {
    await estClient.post('/api/phone/call', {
      body,
    });
  }

  async isRingostatEnabled(): Promise<boolean> {
    return cache.get('ringostat-enabled', async () => {
      const resp = await estClient.get<RingostatConfigReponse>(
        '/api/phone/ringostat/config',
      );

      return resp.ringostatConfig.ringostatConfig.isEnabled;
    });
  }

  async getRingostatConfig(): Promise<RingostatConfig> {
    const resp = await estClient.get<RingostatConfigReponse>(
      '/api/phone/ringostat/config',
    );

    return resp.ringostatConfig.ringostatConfig;
  }

  async updateRingostatConfig(
    config: RingostatConfig,
  ): Promise<RingostatConfig> {
    const resp = await estClient.post<RingostatConfigReponse>(
      '/api/phone/ringostat/config',
      {
        body: { ringostatConfig: config },
      },
    );

    return resp.ringostatConfig.ringostatConfig;
  }
}

export const phoneApi = new PhoneApi();
